export default __webpack_public_path__ + "static/media/splash-landscape.feb9f3be.png";